export const isTemp = (id: string) => id.startsWith("temp-");
export const tempId = () => `temp-${Date.now()}`;
export const trim = (s: string) => s.trim();
export const notEmpty = (s: string) => trim(s).length > 0;

export const validateTabName = (name: string): string | null => {
  if (!notEmpty(name)) return "Tab name must contain at least 1 character";
  return null;
};
